import { render, staticRenderFns } from "./research-modal.vue?vue&type=template&id=ee3e7df0&scoped=true"
import script from "./research-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./research-modal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3e7df0",
  null
  
)

export default component.exports